module.exports = __webpack_public_path__ + "img/28_50.5df48688.png";